import React from "react";
import CustomTooltip from "../../Main/MainCalendarV2/CustomTooltip";
import { getEmployeeNames } from "./employeeListUtils";

function EmployeeTooltip({
  title,
  employees,
  children,
  emptyText = "Список сотрудников недоступен",
}) {
  const names = getEmployeeNames(employees);
  const headerTitle =
    names.length > 0 ? `${title} (${names.length})` : title;

  return (
    <CustomTooltip
      interactive
      bodyClassName="custom-tooltip__body--scrollable"
      headerColor="#EDF8FF"
      content={{
        header: (
          <span style={{ fontWeight: 800, color: "#1A3A5D" }}>{headerTitle}</span>
        ),
        body: names.length ? (
          <div className="hr-dashboard__employee-tooltip-list">
            {names.map((name) => (
              <div key={name} className="hr-dashboard__employee-tooltip-item">
                {name}
              </div>
            ))}
          </div>
        ) : (
          <div style={{ color: "#94a3b8" }}>{emptyText}</div>
        ),
      }}
    >
      {children}
    </CustomTooltip>
  );
}

export default EmployeeTooltip;
